import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  url(id) {
    if (id) {
      return `${window.api_url}/organization/sites/${id}`;
    }
    return `${window.api_url}/organization/sites`;
  },

  create(site, success, failure) {
    axios.post(this.url(), site).then(success).catch(failure);
  },

  destroy(siteId, success) {
    axios.delete(this.url(siteId)).then(success);
  },

  get(siteId, success) {
    if (!success) return axios.get(this.url(siteId));

    axios.get(this.url(siteId)).then(success);
  },

  index(filters, success) {
    if (success) {
      return axios.get(this.url()).then(success);
    }
    return axios.get(this.url(), { params: filters });
  },

  page: {
    url(siteId, pageId) {
      if (pageId) {
        return `${window.api_url}/organization/sites/${siteId}/pages/${pageId}`;
      }
      return `${window.api_url}/organization/sites/${siteId}/pages`;
    },

    get(siteId, pageId, success) {
      axios.get(this.url(siteId, pageId)).then(success);
    },

    update(siteId, pageId, page) {
      return axios.patch(this.url(siteId, pageId), { page }).catch(handleError);
    },
  },

  site_schema: {
    url(siteId, siteSchemaId) {
      if (siteSchemaId) {
        return `${window.api_url}/organization/sites/${siteId}/site_schemas/${siteSchemaId}`;
      }
      return `${window.api_url}/organization/sites/${siteId}/site_schemas`;
    },

    create(siteId, site_schema, success, failure) {
      axios.post(this.url(siteId), { site_schema }).then(success).catch(failure);
    },

    destroy(siteId, siteSchemaId, success) {
      axios.delete(this.url(siteId, siteSchemaId)).then(success);
    },

    index(siteId, success) {
      axios.get(this.url(siteId)).then(success);
    },
  },

  // eslint-disable-next-line no-restricted-syntax -- Match existing nested site API namespace convention.
  sso_connection: {
    url(siteId, ssoConnectionId) {
      if (ssoConnectionId) {
        return `${window.api_url}/organization/sites/${siteId}/sso_connections/${ssoConnectionId}`;
      }
      return `${window.api_url}/organization/sites/${siteId}/sso_connections`;
    },

    async create(siteId, ssoConnection, success, failure) {
      try {
        const response = await axios.post(this.url(siteId), { sso_connection: ssoConnection });
        if (success) success(response);
        return response;
      } catch (error) {
        if (failure) return failure(error);
        return handleError(error);
      }
    },

    async destroy(siteId, ssoConnectionId, success, failure) {
      try {
        const response = await axios.delete(this.url(siteId, ssoConnectionId));
        if (success) success(response);
        return response;
      } catch (error) {
        if (failure) return failure(error);
        return handleError(error);
      }
    },

    async index(siteId, success, failure) {
      try {
        const response = await axios.get(this.url(siteId));
        if (success) success(response);
        return response;
      } catch (error) {
        if (failure) return failure(error);
        return handleError(error);
      }
    },

    async update(siteId, ssoConnectionId, ssoConnection, success, failure) {
      try {
        const response = await axios.patch(this.url(siteId, ssoConnectionId), {
          sso_connection: ssoConnection,
        });
        if (success) success(response);
        return response;
      } catch (error) {
        if (failure) return failure(error);
        return handleError(error);
      }
    },
  },

  update(id, site, success, failure) {
    if (!success) return axios.patch(this.url(id), { site }).catch(handleError);

    return axios.patch(this.url(id), { site }).then(success).catch(failure);
  },

  updateOrCreate(site, success, failure) {
    if (site.id) {
      this.update(site.id, site, success, failure);
    } else {
      this.create(site, success, failure);
    }
  },

  provisionDomain(siteId, domain) {
    return axios.post(`${this.url(siteId)}/provision_domain`, { domain }).catch((error) => {
      handleError(error);
      return Promise.reject(error);
    });
  },
};
